module.exports = __webpack_public_path__ + "static/media/ipnos-component-1.b6b04476.png";